import { Teachers, ELearningDashboardClass, ELearningDashboardState, StudentLesson } from '../Elearning-Models';


export class StudentLessons{
    public studentLessons: StudentLesson[] = [
        
    {
        "AssignmentName":"Introduction to Psychological Perspectives1",
        "StartDate": "05/05/05",
        "DueDate": "06/06/06",
        "ClassName":"English Language Arts 6 ",
        "ClassDesc": "Period 3(Monday) Period 4(Monday-Tuesday,Friday) Period 5(Tuesday) Period 6(Wednesday-Thursday)",
        "TeacherFullName" : "Mr. NoHands",
        "AssignmentID" : 2
    },{
        "AssignmentName":"Introduction to Psychological Perspectives",
        "StartDate": "05/05/05",
        "DueDate": "06/06/06",
        "ClassName":"Class 2",
        "ClassDesc": "Period 3 - Section 1",
        "TeacherFullName" : "Mr. NoHands",
        "AssignmentID" : 2
    },{
        "AssignmentName":"Introduction to Psychological Perspectives",
        "StartDate": "05/05/05",
        "DueDate": "06/06/06",
        "ClassName":"Class 2",
        "ClassDesc": "Period 3 - Section 1",
        "TeacherFullName" : "Mr. NoHands",
        "AssignmentID" : 2
    },{
        "AssignmentName":"Introduction to Psychological Perspectives",
        "StartDate": "05/05/05",
        "DueDate": "06/06/06",
        "ClassName":"Class 2",
        "ClassDesc": "Period 3 - Section 1",
        "TeacherFullName" : "Mr. NoHands",
        "AssignmentID" : 2
    },{
        "AssignmentName":"Introduction to Psychological Perspectives",
        "StartDate": "05/05/05",
        "DueDate": "06/06/06",
        "ClassName":"Class 2",
        "ClassDesc": "Period 3 - Section 1",
        "TeacherFullName" : "Mr. NoHands",
        "AssignmentID" : 2
    },
];
}


export class AdminData {

public teachers: Teachers = {
    IsAdmin:true,
    Teachers:[{"CustID":105,"UserID":525104,"UserName":"JAdaHarris","FirstName":"Jenny Smith","LastName":"Ada Harris","Active":true,"UserTypeId":2},{"CustID":105,"UserID":26620,"UserName":"fadamsnw","FirstName":"Franca","LastName":"Adams","Active":true,"UserTypeId":2},{"CustID":105,"UserID":26621,"UserName":"JAgostino","FirstName":"Jack","LastName":"Agostino","Active":true,"UserTypeId":2},{"CustID":105,"UserID":407908,"UserName":"MAlbano","FirstName":"Michael","LastName":"Albano","Active":true,"UserTypeId":2},{"CustID":105,"UserID":525083,"UserName":"AAllar","FirstName":"Amanda","LastName":"Allar","Active":true,"UserTypeId":2},{"CustID":105,"UserID":466784,"UserName":"NAltamura2","FirstName":"Nicole","LastName":"Altamura","Active":true,"UserTypeId":2},{"CustID":105,"UserID":26628,"UserName":"JAmmirati","FirstName":"John","LastName":"Ammirati","Active":true,"UserTypeId":2},{"CustID":105,"UserID":26631,"UserName":"MAsbell","FirstName":"Melissa","LastName":"Asbell","Active":true,"UserTypeId":2},{"CustID":105,"UserID":494345,"UserName":"MAshe","FirstName":"Megan","LastName":"Ashe","Active":true,"UserTypeId":2},{"CustID":105,"UserID":26632,"UserName":"DAttanasio","FirstName":"Dawn","LastName":"Attanasio","Active":true,"UserTypeId":2},{"CustID":105,"UserID":26816,"UserName":"DAversa","FirstName":"Daren","LastName":"Aversa","Active":true,"UserTypeId":2},{"CustID":105,"UserID":26633,"UserName":"daversane","FirstName":"Dyan","LastName":"Aversa","Active":true,"UserTypeId":2},{"CustID":105,"UserID":525076,"UserName":"EAzzara","FirstName":"Erica","LastName":"Azzara","Active":true,"UserTypeId":2},{"CustID":105,"UserID":316278,"UserName":"aBabington","FirstName":"Andrew","LastName":"Babington","Active":true,"UserTypeId":2},{"CustID":105,"UserID":525092,"UserName":"NBaerenklau","FirstName":"Nicholas","LastName":"Baerenklau","Active":true,"UserTypeId":2},{"CustID":105,"UserID":466772,"UserName":"NBass","FirstName":"Nicole","LastName":"Bass","Active":true,"UserTypeId":2},{"CustID":105,"UserID":537890,"UserName":"SBasu","FirstName":"Suparna","LastName":"Basu","Active":true,"UserTypeId":2},{"CustID":105,"UserID":26729,"UserName":"TRobins","FirstName":"Tonya","LastName":"Bates","Active":true,"UserTypeId":2},{"CustID":105,"UserID":466781,"UserName":"KBeleckas1","FirstName":"Kathryn","LastName":"Beleckas","Active":true,"UserTypeId":2},{"CustID":105,"UserID":384211,"UserName":"jbianco","FirstName":"Jennifer","LastName":"Bianco","Active":true,"UserTypeId":2},{"CustID":105,"UserID":26642,"UserName":"bbielecka","FirstName":"Barbara","LastName":"Bielecka","Active":true,"UserTypeId":2},{"CustID":105,"UserID":4948,"UserName":"jpentangelo","FirstName":"Jennifer","LastName":"Bisulca","Active":true,"UserTypeId":2},{"CustID":105,"UserID":26540,"UserName":"CGambella","FirstName":"Christine","LastName":"Bloom","Active":true,"UserTypeId":2},{"CustID":105,"UserID":43366,"UserName":"TBOCES","FirstName":"TBA","LastName":"BOCES","Active":true,"UserTypeId":2},{"CustID":105,"UserID":26643,"UserName":"CBoehringer","FirstName":"Cara","LastName":"Boehringer","Active":true,"UserTypeId":2},{"CustID":105,"UserID":26646,"UserName":"mbrooks","FirstName":"Margaret","LastName":"Brooks","Active":true,"UserTypeId":2},{"CustID":105,"UserID":26648,"UserName":"HBrown","FirstName":"Hilda","LastName":"Brown","Active":true,"UserTypeId":2}]
};

public classes: ELearningDashboardClass[] = [];

public classesFromTeacherID: ELearningDashboardClass[] = [{"ID":563528,"NoLessonsYet": false,"Name":"Economics","Hidden":false,"CurriculumID":1,"ClassHomePageUrl":"/classroom?classID=563528&className=Economics","CurriculumUrl":"","Students":[{"ID":16113,"Name":"Valeriano, Giovanni","ActiveLessons": 1, "NeedsAssignment":false,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"NeedsGradeReleasedCount":0},{"ID":29441,"Name":"Hatcher, Di'jhea","ActiveLessons": 0,"NeedsAssignment":true,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"NeedsGradeReleasedCount":0},{"ID":525471,"Name":"Cruz-Benitez, Elmer","ActiveLessons": 0,"NeedsAssignment":true,"LastAssignmentSubmitDate":"","NeedsGradingCount":1,"NeedsGradeReleasedCount":0},{"ID":540863,"Name":"Guevara Ferrufino, Luis","ActiveLessons": 0,"NeedsAssignment":true,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"NeedsGradeReleasedCount":0},{"ID":433361,"Name":"Myerssssssss otherlonglastname, Monieka","ActiveLessons": 0,"NeedsAssignment":true,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"NeedsGradeReleasedCount":0},{"ID":416634,"Name":"Paredes Gonzalez, Ruth","ActiveLessons": 0,"NeedsAssignment":true,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"NeedsGradeReleasedCount":0},{"ID":386329,"Name":"Washington, Jacob","ActiveLessons": 0,"NeedsAssignment":true,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"NeedsGradeReleasedCount":0},{"ID":407922,"Name":"Gil Chalco, Esthefany","NeedsAssignment":true,"LastAssignmentSubmitDate":"","ActiveLessons": 0,"NeedsGradingCount":0,"NeedsGradeReleasedCount":0},{"ID":316145,"Name":"Orellana Escobar, Keila","NeedsAssignment":true,"ActiveLessons": 0,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"NeedsGradeReleasedCount":0},{"ID":343188,"Name":"Ortiz Guzman, Jenniffer","NeedsAssignment":true,"LastAssignmentSubmitDate":"","ActiveLessons": 5,"NeedsGradingCount":3,"NeedsGradeReleasedCount":2},{"ID":308580,"Name":"Hernandez Cruz, Sorayda","NeedsAssignment":true,"LastAssignmentSubmitDate":"","ActiveLessons": 0,"NeedsGradingCount":0,"NeedsGradeReleasedCount":0},{"ID":30616,"Name":"Gutierrez-Vigil, Ever","NeedsAssignment":true,"ActiveLessons": 0,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"NeedsGradeReleasedCount":0},{"ID":30400,"Name":"Scruggs, Rashad","NeedsAssignment":true,"LastAssignmentSubmitDate":"","ActiveLessons": 0,"NeedsGradingCount":0,"NeedsGradeReleasedCount":0},{"ID":30456,"Name":"Johnson, Anthone'","NeedsAssignment":true,"LastAssignmentSubmitDate":"","ActiveLessons": 0,"NeedsGradingCount":0,"NeedsGradeReleasedCount":3},{"ID":30320,"Name":"Williams, Jaleel","NeedsAssignment":true,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"ActiveLessons": 0,"NeedsGradeReleasedCount":0},{"ID":30334,"Name":"Canales, Gloria","NeedsAssignment":true,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"ActiveLessons": 0,"NeedsGradeReleasedCount":0},{"ID":30338,"Name":"Rubio, Cristian","NeedsAssignment":true,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"ActiveLessons": 0,"NeedsGradeReleasedCount":0}]},{"ID":563522,"NoLessonsYet": false,"Name":"Essentials in Global History","Hidden":false,"CurriculumID":null,"ClassHomePageUrl":"/classroom?classID=563522&className=Essentials+in+Global+History","CurriculumUrl":"/Curriculum/View/","Students":[{"ID":29409,"Name":"Ramirez, Luis","NeedsAssignment":true,"ActiveLessons": 0,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"NeedsGradeReleasedCount":0},{"ID":30338,"Name":"Rubio, Cristian","NeedsAssignment":true,"ActiveLessons": 0,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"NeedsGradeReleasedCount":0}]},{"ID":563531,"NoLessonsYet": true,"Name":"Essentials in Living Environment-Fall","Hidden":false,"CurriculumID":55555,"ClassHomePageUrl":"/classroom?classID=563531&className=Essentials+in+Living+Environment-Fall","CurriculumUrl":"/Curriculum/View/","Students":[{"ID":29416,"Name":"Vasquez, Luis","NeedsAssignment":true,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"ActiveLessons": 0,"NeedsGradeReleasedCount":0},{"ID":525471,"Name":"Cruz-Benitez, Elmer","NeedsAssignment":true,"LastAssignmentSubmitDate":"","ActiveLessons": 0,"NeedsGradingCount":0,"NeedsGradeReleasedCount":0},{"ID":343200,"Name":"Palenzuela Veloz, Claudia","NeedsAssignment":true,"LastAssignmentSubmitDate":"","ActiveLessons": 0,"NeedsGradingCount":0,"NeedsGradeReleasedCount":0},{"ID":343188,"Name":"Ortiz Guzman, Jenniffer","NeedsAssignment":true,"LastAssignmentSubmitDate":"","ActiveLessons": 0,"NeedsGradingCount":0,"NeedsGradeReleasedCount":0},{"ID":100970,"Name":"Turenne, Sarah","NeedsAssignment":true,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"ActiveLessons": 0,"NeedsGradeReleasedCount":0},{"ID":30400,"Name":"Scruggs, Rashad","NeedsAssignment":true,"ActiveLessons": 0,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"NeedsGradeReleasedCount":0},{"ID":30570,"Name":"Harrison, Tyrese","NeedsAssignment":true,"ActiveLessons": 0,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"NeedsGradeReleasedCount":0},{"ID":30334,"Name":"Canales, Gloria","NeedsAssignment":true,"ActiveLessons": 0,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"NeedsGradeReleasedCount":0}]},{"ID":563524,"NoLessonsYet": false,"Name":"Global St. 10R","Hidden":false,"CurriculumID":null,"ClassHomePageUrl":"/classroom?classID=563524&className=Global+St.+10R","CurriculumUrl":"/Curriculum/View/","Students":[{"ID":29842,"Name":"Cruz Jr, Mauricio","NeedsAssignment":true,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"ActiveLessons": 0,"NeedsGradeReleasedCount":0},{"ID":486382,"ActiveLessons": 0,"Name":"Barrera Orellana, Lily","NeedsAssignment":true,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"NeedsGradeReleasedCount":0},{"ID":466877,"ActiveLessons": 0,"Name":"Rodriguez, Mark","NeedsAssignment":true,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"NeedsGradeReleasedCount":0},{"ID":407922,"ActiveLessons": 0,"Name":"Gil Chalco, Esthefany","NeedsAssignment":true,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"NeedsGradeReleasedCount":0},{"ID":416585,"ActiveLessons": 0,"Name":"Jones, Zachary","NeedsAssignment":true,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"NeedsGradeReleasedCount":0},{"ID":343200,"ActiveLessons": 0,"Name":"Palenzuela Veloz, Claudia","NeedsAssignment":true,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"NeedsGradeReleasedCount":0},{"ID":362150,"ActiveLessons": 0,"Name":"Carbajal Reyes, Elmer","NeedsAssignment":true,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"NeedsGradeReleasedCount":0},{"ID":30570,"ActiveLessons": 0,"Name":"Harrison, Tyrese","NeedsAssignment":true,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"NeedsGradeReleasedCount":0},{"ID":30586,"ActiveLessons": 0,"Name":"Devine, Dahvontay","NeedsAssignment":true,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"NeedsGradeReleasedCount":0},{"ID":86236,"Name":"Madrid, Wilmer","ActiveLessons": 0,"NeedsAssignment":true,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"NeedsGradeReleasedCount":0},{"ID":94549,"Name":"Benjamin, Dion","NeedsAssignment":true,"ActiveLessons": 0,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"NeedsGradeReleasedCount":0},{"ID":30109,"Name":"Arshad, Sharmin","NeedsAssignment":true,"LastAssignmentSubmitDate":"","ActiveLessons": 0,"NeedsGradingCount":0,"NeedsGradeReleasedCount":0}]},{"ID":563515,"NoLessonsYet": false,"Name":"Global St. 9R","Hidden":false,"CurriculumID":null,"ClassHomePageUrl":"/classroom?classID=563515&className=Global+St.+9R","CurriculumUrl":"/Curriculum/View/","Students":[{"ID":30003,"Name":"Perez, Marvin","NeedsAssignment":true,"ActiveLessons": 0,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"NeedsGradeReleasedCount":0},{"ID":94549,"Name":"Benjamin, Dion","NeedsAssignment":true,"LastAssignmentSubmitDate":"","ActiveLessons": 0,"NeedsGradingCount":0,"NeedsGradeReleasedCount":0},{"ID":100922,"Name":"Evans, Christian","NeedsAssignment":true,"LastAssignmentSubmitDate":"","ActiveLessons": 0,"NeedsGradingCount":0,"NeedsGradeReleasedCount":0}]},{"ID":563516,"NoLessonsYet": false,"Name":"Essentials in Global History","Hidden":false,"CurriculumID":null,"ClassHomePageUrl":"/classroom?classID=563516&className=Essentials+in+Global+History","CurriculumUrl":"/Curriculum/View/","Students":[{"ID":525471,"Name":"Cruz-Benitez, Elmer","NeedsAssignment":true,"ActiveLessons": 0,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"NeedsGradeReleasedCount":0},{"ID":418416,"Name":"McCloud, Tyquis","NeedsAssignment":true,"ActiveLessons": 0,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"NeedsGradeReleasedCount":0},{"ID":316145,"Name":"Orellana Escobar, Keila","NeedsAssignment":true,"ActiveLessons": 0,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"NeedsGradeReleasedCount":0}]},{"ID":563510,"NoLessonsYet": false,"Name":"Liv Envir R","Hidden":false,"CurriculumID":null,"ClassHomePageUrl":"/classroom?classID=563510&className=Liv+Envir+R","CurriculumUrl":"/Curriculum/View/","Students":[{"ID":418416,"Name":"McCloud, Tyquis","ActiveLessons": 0,"NeedsAssignment":true,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"NeedsGradeReleasedCount":0},{"ID":469639,"Name":"Linares Martinez, Jose","ActiveLessons": 0,"NeedsAssignment":true,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"NeedsGradeReleasedCount":0},{"ID":486382,"Name":"Barrera Orellana, Lily","ActiveLessons": 0,"NeedsAssignment":true,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"NeedsGradeReleasedCount":0},{"ID":407922,"Name":"Gil Chalco, Esthefany","ActiveLessons": 0,"NeedsAssignment":true,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"NeedsGradeReleasedCount":0},{"ID":416585,"Name":"Jones, Zachary","NeedsAssignment":true,"ActiveLessons": 0,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"NeedsGradeReleasedCount":0},{"ID":362150,"Name":"Carbajal Reyes, Elmer","NeedsAssignment":true,"LastAssignmentSubmitDate":"","ActiveLessons": 0,"NeedsGradingCount":0,"NeedsGradeReleasedCount":0},{"ID":100922,"Name":"Evans, Christian","NeedsAssignment":true,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"ActiveLessons": 0,"NeedsGradeReleasedCount":0},{"ID":30586,"Name":"Devine, Dahvontay","NeedsAssignment":true,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"ActiveLessons": 0,"NeedsGradeReleasedCount":0},{"ID":30511,"Name":"Creary, Jah-shera","NeedsAssignment":true,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"ActiveLessons": 0,"NeedsGradeReleasedCount":0},{"ID":30003,"Name":"Perez, Marvin","NeedsAssignment":true,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"ActiveLessons": 0,"NeedsGradeReleasedCount":0}]},{"ID":563532,"NoLessonsYet": false,"Name":"Essentials in Living Environment-Fall","Hidden":false,"CurriculumID":null,"ClassHomePageUrl":"/classroom?classID=563532&className=Essentials+in+Living+Environment-Fall","CurriculumUrl":"/Curriculum/View/","Students":[{"ID":469639,"Name":"Linares Martinez, Jose","ActiveLessons": 0,"NeedsAssignment":true,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"NeedsGradeReleasedCount":0},{"ID":316145,"Name":"Orellana Escobar, Keila","ActiveLessons": 0,"NeedsAssignment":true,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"NeedsGradeReleasedCount":0},{"ID":316239,"Name":"Quintanilla Portillo, Yuri","ActiveLessons": 0,"NeedsAssignment":true,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"NeedsGradeReleasedCount":0}]},{"ID":563511,"NoLessonsYet": false,"Name":"Liv Envir R","Hidden":false,"CurriculumID":null,"ClassHomePageUrl":"/classroom?classID=563511&className=Liv+Envir+R","CurriculumUrl":"/Curriculum/View/","Students":[{"ID":94549,"ActiveLessons": 0,"Name":"Benjamin, Dion","NeedsAssignment":true,"LastAssignmentSubmitDate":"","NeedsGradingCount":0,"NeedsGradeReleasedCount":0}]},{"ID":563511,"NoLessonsYet": false,"Name":"Liv Envir R","Hidden":false,"CurriculumID":null,"ClassHomePageUrl":"/classroom?classID=563511&className=Liv+Envir+R","CurriculumUrl":"/Curriculum/View/","Students":[{"ID":94549,"ActiveLessons": 0,"Name":"Benjamin, Dion","NeedsAssignment":true,"LastAssignmentSubmitDate":"","NeedsGradingCount":1,"NeedsGradeReleasedCount":0}]}]
}


export class TeacherData {

    public teachers: Teachers = {
        IsAdmin:false,
        Teachers:[]
    };

    public classes: ELearningDashboardClass[] = [
      {
         "ID":1,
         "NoLessonsYet":false,
         "Name":"Economics",
         "Hidden":false,
         "CurriculumID":5,
         "ClassHomePageUrl":"/classroom?classID=563528&className=Economics",
         "CurriculumUrl":"/Curriculum/View/5",
         "Students":[
            {
               "ID":16113,
               "ActiveLessons":0,
               "Name":"Valeriano, Giovanni",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "NeedsGradeReleasedCount":1
            },
            {
               "ID":29441,
               "ActiveLessons":0,
               "Name":"Keihanaikukauakahihuliheekahaunaele, Kaulana Ka na'auau o na Kupuna",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":10,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":525471,
               "Name":"Cruz-Benitez, Elmer",
               "NeedsAssignment":false,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":1,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":540863,
               "Name":"Guevara Ferrufino, Luis",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "ActiveLessons":0,
               "NeedsGradingCount":0,
               "NeedsGradeReleasedCount":1
            },
            {
               "ID":433361,
               "Name":"Myerssssssss otherlonglastname, Monieka",
               "ActiveLessons":0,
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"June 6, 2020",
               "NeedsGradingCount":1,
               "NeedsGradeReleasedCount":1
            },
            {
               "ID":416634,
               "ActiveLessons":0,
               "Name":"Paredes Gonzalez, Ruth",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":386329,
               "ActiveLessons":0,
               "Name":"Washington, Jacob",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":407922,
               "ActiveLessons":0,
               "Name":"Gil Chalco, Esthefany",
               "NeedsAssignment":false,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "NeedsGradeReleasedCount":1
            },
            {
               "ID":316145,
               "Name":"Orellana Escobar, Keila",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":1,
               "ActiveLessons":5,
               "NeedsGradeReleasedCount":1
            },
            {
               "ID":343188,
               "ActiveLessons":0,
               "Name":"Ortiz Guzman, Jenniffer",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":308580,
               "ActiveLessons":0,
               "Name":"Hernandez Cruz, Sorayda",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":1,
               "NeedsGradeReleasedCount":1
            },
            {
               "ID":31616,
               "ActiveLessons":0,
               "Name":"Gutierrez-Vigil, Ever",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":30400,
               "Name":"Scruggs, Rashad",
               "ActiveLessons":0,
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":30456,
               "ActiveLessons":0,
               "Name":"Johnson, Anthone'",
               "NeedsAssignment":false,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "NeedsGradeReleasedCount":1
            },
            {
               "ID":30320,
               "ActiveLessons":1,
               "Name":"Williams, Jaleel",
               "NeedsAssignment":false,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":31334,
               "ActiveLessons":1,
               "Name":"Canales, Gloria",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":1,
               "NeedsGradeReleasedCount":1
            },
            {
               "ID":30338,
               "ActiveLessons":1,
               "Name":"Rubio, Cristian",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"June 6, 2020",
               "NeedsGradingCount":0,
               "NeedsGradeReleasedCount":0
            }
         ]
      },
      {
         "ID":2,
         "NoLessonsYet":true,
         "Name":"Essentials in Global History",
         "Hidden":false,
         "CurriculumID":5555,
         "ClassHomePageUrl":"/classroom?classID=563522&className=Essentials+in+Global+History",
         "CurriculumUrl":"/Curriculum/View/5555",
         "Students":[
            {
               "ID":29409,
               "Name":"Ramirez, Luis",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "ActiveLessons":0,
               "NeedsGradingCount":0,
               "NeedsGradeReleasedCount":1
            },
            {
               "ID":31338,
               "Name":"Rubio, Cristian",
               "NeedsAssignment":false,
               "LastAssignmentSubmitDate":"",
               "ActiveLessons":0,
               "NeedsGradingCount":3,
               "NeedsGradeReleasedCount":0
            }
         ]
      },
      {
         "ID":3,
         "NoLessonsYet":true,
         "Name":"AEssentials in Living Environment-Fall",
         "Hidden":false,
         "CurriculumID":null,
         "ClassHomePageUrl":"/classroom?classID=563531&className=Essentials+in+Living+Environment-Fall",
         "CurriculumUrl":"/Curriculum/View/",
         "Students":[
            {
               "ID":29416,
               "ActiveLessons":0,
               "Name":"Vasquez, Luis",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":525471,
               "ActiveLessons":1,
               "Name":"Cruz-Benitez, Elmer",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "NeedsGradeReleasedCount":1
            },
            {
               "ID":343211,
               "Name":"Palenzuela Veloz, Claudia",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "ActiveLessons":1,
               "NeedsGradingCount":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":343188,
               "Name":"Ortiz Guzman, Jenniffer",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":1,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":111971,
               "Name":"Turenne, Sarah",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "ActiveLessons":0,
               "NeedsGradingCount":1,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":30400,
               "Name":"Scruggs, Rashad",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "ActiveLessons":0,
               "NeedsGradingCount":1,
               "NeedsGradeReleasedCount":1
            },
            {
               "ID":31571,
               "Name":"Harrison, Tyrese",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "ActiveLessons":0,
               "NeedsGradingCount":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":31334,
               "Name":"Canales, Gloria",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "ActiveLessons":2,
               "NeedsGradingCount":1,
               "NeedsGradeReleasedCount":1
            }
         ]
      },
      {
         "ID":4,
         "NoLessonsYet":false,
         "Name":"Global St. 11R",
         "Hidden":false,
         "CurriculumID":null,
         "ClassHomePageUrl":"/classroom?classID=563524&className=Global+St.+10R",
         "CurriculumUrl":"/Curriculum/View/",
         "Students":[
            {
               "ID":29842,
               "Name":"Cruz Jr, Mauricio",
               "ActiveLessons":2,
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":486382,
               "ActiveLessons":2,
               "Name":"Barrera Orellana, Lily",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":466877,
               "ActiveLessons":0,
               "Name":"Rodriguez, Mark",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":407922,
               "ActiveLessons":0,
               "Name":"Gil Chalco, Esthefany",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":416585,
               "ActiveLessons":0,
               "Name":"Jones, Zachary",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":343200,
               "ActiveLessons":2,
               "Name":"Palenzuela Veloz, Claudia",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":362150,
               "ActiveLessons":2,
               "Name":"Carbajal Reyes, Elmer",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":30570,
               "Name":"Harrison, Tyrese",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":2,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":30586,
               "Name":"Devine, Dahvontay",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":86236,
               "Name":"Madrid, Wilmer",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":94549,
               "Name":"Benjamin, Dion",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":30109,
               "Name":"Arshad, Sharmin",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":2,
               "NeedsGradeReleasedCount":0
            }
         ]
      },
      {
         "ID":5,
         "NoLessonsYet":false,
         "Name":"Global St. 9R",
         "Hidden":false,
         "CurriculumID":null,
         "ClassHomePageUrl":"/classroom?classID=563515&className=Global+St.+9R",
         "CurriculumUrl":"/Curriculum/View/",
         "Students":[
            {
               "ID":30003,
               "Name":"Perez, Marvin",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":2,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":94549,
               "Name":"Benjamin, Dion",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":2,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":100922,
               "Name":"Evans, Christian",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            }
         ]
      },
      {
         "ID":6,
         "NoLessonsYet":false,
         "Name":"Essentials in Global History",
         "Hidden":false,
         "CurriculumID":null,
         "ClassHomePageUrl":"/classroom?classID=563516&className=Essentials+in+Global+History",
         "CurriculumUrl":"/Curriculum/View/",
         "Students":[
            {
               "ID":525471,
               "Name":"Cruz-Benitez, Elmer",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":418416,
               "Name":"McCloud, Tyquis",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":316145,
               "Name":"Orellana Escobar, Keila",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            }
         ]
      },
      {
         "ID":7,
         "NoLessonsYet":false,
         "Name":"Liv Envir R",
         "Hidden":false,
         "CurriculumID":null,
         "ClassHomePageUrl":"/classroom?classID=563510&className=Liv+Envir+R",
         "CurriculumUrl":"/Curriculum/View/",
         "Students":[
            {
               "ID":418416,
               "Name":"McCloud, Tyquis",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":469639,
               "Name":"Linares Martinez, Jose",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":486382,
               "Name":"Barrera Orellana, Lily",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":407922,
               "Name":"Gil Chalco, Esthefany",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":416585,
               "Name":"Jones, Zachary",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":25,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":362150,
               "Name":"Carbajal Reyes, Elmer",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":25,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":100922,
               "Name":"Evans, Christian",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":30586,
               "Name":"Devine, Dahvontay",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":30511,
               "Name":"Creary, Jah-shera",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":30003,
               "Name":"Perez, Marvin",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            }
         ]
      },
      {
         "ID":8,
         "NoLessonsYet":false,
         "Name":"Essentials in Living Environment-Fall",
         "Hidden":false,
         "CurriculumID":null,
         "ClassHomePageUrl":"/classroom?classID=563532&className=Essentials+in+Living+Environment-Fall",
         "CurriculumUrl":"/Curriculum/View/",
         "Students":[
            {
               "ID":469639,
               "Name":"Linares Martinez, Jose",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":316145,
               "Name":"Orellana Escobar, Keila",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":316239,
               "Name":"Quintanilla Portillo, Yuri",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":25,
               "NeedsGradeReleasedCount":0
            }
         ]
      },
      {
         "ID":9,
         "NoLessonsYet":false,
         "Name":"Liv Envir R",
         "Hidden":false,
         "CurriculumID":null,
         "ClassHomePageUrl":"/classroom?classID=563511&className=Liv+Envir+R",
         "CurriculumUrl":"/Curriculum/View/",
         "Students":[
            {
               "ID":94549,
               "Name":"Benjamin, Dion",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":1,
               "NeedsGradeReleasedCount":0
            }
         ]
      },
      {
         "ID":10,
         "NoLessonsYet":false,
         "Name":"Global St. 11R",
         "Hidden":false,
         "CurriculumID":null,
         "ClassHomePageUrl":"/classroom?classID=563524&className=Global+St.+10R",
         "CurriculumUrl":"/Curriculum/View/",
         "Students":[
            {
               "ID":29842,
               "Name":"Cruz Jr, Mauricio",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":1,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":486382,
               "Name":"Barrera Orellana, Lily",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":466877,
               "Name":"Rodriguez, Mark",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":407922,
               "Name":"Gil Chalco, Esthefany",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":1,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":416585,
               "Name":"Jones, Zachary",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":1,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":343200,
               "Name":"Palenzuela Veloz, Claudia",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":1,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":362150,
               "Name":"Carbajal Reyes, Elmer",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":30570,
               "Name":"Harrison, Tyrese",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":30586,
               "Name":"Devine, Dahvontay",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":86236,
               "Name":"Madrid, Wilmer",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":94549,
               "Name":"Benjamin, Dion",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":1,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":30109,
               "Name":"Arshad, Sharmin",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":1,
               "NeedsGradeReleasedCount":0
            }
         ]
      },
      {
         "ID":11,
         "NoLessonsYet":false,
         "Name":"Global St. 9R",
         "Hidden":false,
         "CurriculumID":null,
         "ClassHomePageUrl":"/classroom?classID=563515&className=Global+St.+9R",
         "CurriculumUrl":"/Curriculum/View/",
         "Students":[
            {
               "ID":30003,
               "Name":"Perez, Marvin",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":1,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":94549,
               "Name":"Benjamin, Dion",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":100922,
               "Name":"Evans, Christian",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            }
         ]
      },
      {
         "ID":12,
         "NoLessonsYet":false,
         "Name":"Essentials in Global History",
         "Hidden":false,
         "CurriculumID":null,
         "ClassHomePageUrl":"/classroom?classID=563516&className=Essentials+in+Global+History",
         "CurriculumUrl":"/Curriculum/View/",
         "Students":[
            {
               "ID":525471,
               "Name":"Cruz-Benitez, Elmer",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":418416,
               "Name":"McCloud, Tyquis",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":316145,
               "Name":"Orellana Escobar, Keila",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            }
         ]
      },
      {
         "ID":13,
         "NoLessonsYet":false,
         "Name":"Liv Envir R",
         "Hidden":false,
         "CurriculumID":null,
         "ClassHomePageUrl":"/classroom?classID=563510&className=Liv+Envir+R",
         "CurriculumUrl":"/Curriculum/View/",
         "Students":[
            {
               "ID":418416,
               "Name":"McCloud, Tyquis",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":1,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":469639,
               "Name":"Linares Martinez, Jose",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":1,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":486382,
               "Name":"Barrera Orellana, Lily",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":1,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":407922,
               "Name":"Gil Chalco, Esthefany",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":416585,
               "Name":"Jones, Zachary",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":362150,
               "Name":"Carbajal Reyes, Elmer",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":2,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":100922,
               "Name":"Evans, Christian",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":2,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":30586,
               "Name":"Devine, Dahvontay",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":2,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":30511,
               "Name":"Creary, Jah-shera",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":30003,
               "Name":"Perez, Marvin",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            }
         ]
      },
      {
         "ID":14,
         "NoLessonsYet":false,
         "Name":"AEssentials in Living Environment-Fall",
         "Hidden":false,
         "CurriculumID":55,
         "ClassHomePageUrl":"/classroom?classID=563532&className=Essentials+in+Living+Environment-Fall",
         "CurriculumUrl":"/Curriculum/View/",
         "Students":[
            {
               "ID":469639,
               "Name":"Linares Martinez, Jose",
               "NeedsAssignment":false,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":316145,
               "Name":"Orellana Escobar, Keila",
               "NeedsAssignment":false,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":316239,
               "Name":"Quintanilla Portillo, Yuri",
               "NeedsAssignment":false,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            }
         ]
      },
      {
         "ID":15,
         "NoLessonsYet":false,
         "Name":"Liv Envir R",
         "Hidden":false,
         "CurriculumID":null,
         "ClassHomePageUrl":"/classroom?classID=563511&className=Liv+Envir+R",
         "CurriculumUrl":"/Curriculum/View/",
         "Students":[
            {
               "ID":94549,
               "Name":"Benjamin, Dion",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            }
         ]
      },
      {
         "ID":16,
         "NoLessonsYet":false,
         "Name":"Global St. 11R",
         "Hidden":false,
         "CurriculumID":null,
         "ClassHomePageUrl":"/classroom?classID=563524&className=Global+St.+10R",
         "CurriculumUrl":"/Curriculum/View/",
         "Students":[
            {
               "ID":29842,
               "Name":"Cruz Jr, Mauricio",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":486382,
               "Name":"Barrera Orellana, Lily",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":466877,
               "Name":"Rodriguez, Mark",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":2,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":407922,
               "Name":"Gil Chalco, Esthefany",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":2,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":416585,
               "Name":"Jones, Zachary",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":2,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":343200,
               "Name":"Palenzuela Veloz, Claudia",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":362150,
               "Name":"Carbajal Reyes, Elmer",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":30570,
               "Name":"Harrison, Tyrese",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":30586,
               "Name":"Devine, Dahvontay",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":86236,
               "Name":"Madrid, Wilmer",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":94549,
               "Name":"Benjamin, Dion",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":30109,
               "Name":"Arshad, Sharmin",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":2,
               "NeedsGradeReleasedCount":0
            }
         ]
      },
      {
         "ID":17,
         "NoLessonsYet":false,
         "Name":"Global St. 9R",
         "Hidden":false,
         "CurriculumID":null,
         "ClassHomePageUrl":"/classroom?classID=563515&className=Global+St.+9R",
         "CurriculumUrl":"/Curriculum/View/",
         "Students":[
            {
               "ID":30003,
               "Name":"Perez, Marvin",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":2,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":94549,
               "Name":"Benjamin, Dion",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":2,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":100922,
               "Name":"Evans, Christian",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            }
         ]
      },
      {
         "ID":18,
         "NoLessonsYet":false,
         "Name":"Essentials in Global History",
         "Hidden":false,
         "CurriculumID":null,
         "ClassHomePageUrl":"/classroom?classID=563516&className=Essentials+in+Global+History",
         "CurriculumUrl":"/Curriculum/View/",
         "Students":[
            {
               "ID":525471,
               "Name":"Cruz-Benitez, Elmer",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":418416,
               "Name":"McCloud, Tyquis",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":316145,
               "Name":"Orellana Escobar, Keila",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            }
         ]
      },
      {
         "ID":19,
         "NoLessonsYet":false,
         "Name":"Liv Envir R",
         "Hidden":false,
         "CurriculumID":null,
         "ClassHomePageUrl":"/classroom?classID=563510&className=Liv+Envir+R",
         "CurriculumUrl":"/Curriculum/View/",
         "Students":[
            {
               "ID":418416,
               "Name":"McCloud, Tyquis",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":469639,
               "Name":"Linares Martinez, Jose",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":486382,
               "Name":"Barrera Orellana, Lily",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":2,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":407922,
               "Name":"Gil Chalco, Esthefany",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":2,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":416585,
               "Name":"Jones, Zachary",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":362150,
               "Name":"Carbajal Reyes, Elmer",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":100922,
               "Name":"Evans, Christian",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":30586,
               "Name":"Devine, Dahvontay",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":30511,
               "Name":"Creary, Jah-shera",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":30003,
               "Name":"Perez, Marvin",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            }
         ]
      },
      {
         "ID":20,
         "NoLessonsYet":false,
         "Name":"Essentials in Living Environment-Fall",
         "Hidden":false,
         "CurriculumID":null,
         "ClassHomePageUrl":"/classroom?classID=563532&className=Essentials+in+Living+Environment-Fall",
         "CurriculumUrl":"/Curriculum/View/",
         "Students":[
            {
               "ID":469639,
               "Name":"Linares Martinez, Jose",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":316145,
               "Name":"Orellana Escobar, Keila",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            },
            {
               "ID":316239,
               "Name":"Quintanilla Portillo, Yuri",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            }
         ]
      },
      {
         "ID":21,
         "NoLessonsYet":false,
         "Name":"Liv Envir R",
         "Hidden":false,
         "CurriculumID":null,
         "ClassHomePageUrl":"/classroom?classID=563511&className=Liv+Envir+R",
         "CurriculumUrl":"/Curriculum/View/",
         "Students":[
            {
               "ID":94549,
               "Name":"Benjamin, Dion",
               "NeedsAssignment":true,
               "LastAssignmentSubmitDate":"",
               "NeedsGradingCount":0,
               "ActiveLessons":0,
               "NeedsGradeReleasedCount":0
            }
         ]
      }
   ]
}

export class TeacherTEST {
    public teachers: Teachers = {
        "IsAdmin":true,
        "Teachers":[
           {
              "CustID":105,
              "UserID":811275,
              "UserName":"MAbbondondolo1",
              "FirstName":"Michael",
              "LastName":"Abbondondolo",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26620,
              "UserName":"fadamsnw",
              "FirstName":"Franca",
              "LastName":"Adams",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":407908,
              "UserName":"MAlbano",
              "FirstName":"Michael",
              "LastName":"Albano",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":466784,
              "UserName":"NAltamura",
              "FirstName":"Nicole",
              "LastName":"Altamura",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26628,
              "UserName":"JAmmirati",
              "FirstName":"John",
              "LastName":"Ammirati",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":816908,
              "UserName":"SAnderson",
              "FirstName":"Shayna",
              "LastName":"Anderson",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":711059,
              "UserName":"RAnnese",
              "FirstName":"Robert",
              "LastName":"Annese",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26631,
              "UserName":"MAsbell",
              "FirstName":"Melissa",
              "LastName":"Asbell",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":494345,
              "UserName":"MAshe",
              "FirstName":"Megan",
              "LastName":"Ashe",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":882413,
              "UserName":"PAthanasiou",
              "FirstName":"Paraskevi",
              "LastName":"Athanasiou",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26632,
              "UserName":"DAttanasio",
              "FirstName":"Dawn",
              "LastName":"Attanasio",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26816,
              "UserName":"DAversa",
              "FirstName":"Daren",
              "LastName":"Aversa",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26633,
              "UserName":"daversane",
              "FirstName":"Dyan",
              "LastName":"Aversa",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26736,
              "UserName":"CRomeo",
              "FirstName":"Christina",
              "LastName":"Aversano",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":586491,
              "UserName":"eazzara_ms",
              "FirstName":"Erica",
              "LastName":"Azzara",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":811283,
              "UserName":"ABabington",
              "FirstName":"Andrew",
              "LastName":"Babington",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":586496,
              "UserName":"sbasu_ms",
              "FirstName":"Suparna",
              "LastName":"Basu",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26729,
              "UserName":"tbates",
              "FirstName":"Tonya",
              "LastName":"Bates",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":704622,
              "UserName":"nbaxter",
              "FirstName":"Nicole",
              "LastName":"Baxter",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":384211,
              "UserName":"jbianco",
              "FirstName":"Jennifer",
              "LastName":"Bianco",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26540,
              "UserName":"CGambella",
              "FirstName":"Christine",
              "LastName":"Bloom",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26643,
              "UserName":"CBoehringer",
              "FirstName":"Cara",
              "LastName":"Boehringer",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":882415,
              "UserName":"JBoell1",
              "FirstName":"John",
              "LastName":"Boell",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":711068,
              "UserName":"MBonasera",
              "FirstName":"Michael",
              "LastName":"Bonasera",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26603,
              "UserName":"claviano",
              "FirstName":"Candice",
              "LastName":"Bonelli",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26646,
              "UserName":"mbrooks",
              "FirstName":"Margaret",
              "LastName":"Brooks",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26648,
              "UserName":"HBrown",
              "FirstName":"Hilda",
              "LastName":"Brown",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26649,
              "UserName":"SBrown",
              "FirstName":"Stephanie",
              "LastName":"Brown",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":418385,
              "UserName":"CBrunson",
              "FirstName":"Carlee",
              "LastName":"Brunson",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":7610,
              "UserName":"jbuckley",
              "FirstName":"John",
              "LastName":"Buckley",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":418386,
              "UserName":"RBueno",
              "FirstName":"Reynaldo",
              "LastName":"Bueno",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26818,
              "UserName":"VBuonomo",
              "FirstName":"Victoria",
              "LastName":"Buonomo",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":469387,
              "UserName":"SBura",
              "FirstName":"Stacey",
              "LastName":"Bura",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26654,
              "UserName":"KButton",
              "FirstName":"Kristen",
              "LastName":"Button",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":882405,
              "UserName":"JByrd",
              "FirstName":"Jessica",
              "LastName":"Byrd",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":466776,
              "UserName":"MCalderon",
              "FirstName":"Maria",
              "LastName":"Calderon",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":882404,
              "UserName":"BCallahan1",
              "FirstName":"Brian",
              "LastName":"Callahan",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26656,
              "UserName":"JCallahan",
              "FirstName":"Jennifer",
              "LastName":"Callahan",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":316273,
              "UserName":"TCammaroto",
              "FirstName":"Trish",
              "LastName":"Cammaroto",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26659,
              "UserName":"JCardone",
              "FirstName":"John",
              "LastName":"Cardone",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":308608,
              "UserName":"LCarey",
              "FirstName":"Lisa",
              "LastName":"Carey",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26758,
              "UserName":"ssmithhs",
              "FirstName":"Suzanne",
              "LastName":"Carlucci",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26660,
              "UserName":"YCarman",
              "FirstName":"Yvette",
              "LastName":"Carman",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":480924,
              "UserName":"DCarrero",
              "FirstName":"Danielle",
              "LastName":"Carrero",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":563400,
              "UserName":"DMackenzieReddin1",
              "FirstName":"Danielle",
              "LastName":"Carrero",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":8050,
              "UserName":"mcarrua",
              "FirstName":"Maria",
              "LastName":"Carrua",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":542982,
              "UserName":"ACasey",
              "FirstName":"Annemarie",
              "LastName":"Casey",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26661,
              "UserName":"SCastagna",
              "FirstName":"Susan",
              "LastName":"Castagna",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26662,
              "UserName":"ECastro",
              "FirstName":"Elisa",
              "LastName":"Castro",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":525086,
              "UserName":"NCastro",
              "FirstName":"Nicholas",
              "LastName":"Castro",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":451464,
              "UserName":"RChandler",
              "FirstName":"Renee",
              "LastName":"Chandler",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26665,
              "UserName":"CCharles",
              "FirstName":"Colleen",
              "LastName":"Charles",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26601,
              "UserName":"NCiancarelli",
              "FirstName":"Nicole",
              "LastName":"Ciancarelli",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":727018,
              "UserName":"LCiliotta",
              "FirstName":"Leslie",
              "LastName":"Ciliotta",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":586486,
              "UserName":"pcimmino",
              "FirstName":"Paul",
              "LastName":"Cimmino",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":466782,
              "UserName":"RClaps1",
              "FirstName":"Robert",
              "LastName":"Claps",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":811279,
              "UserName":"KCoard",
              "FirstName":"Kenneth",
              "LastName":"Coard",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":811274,
              "UserName":"MCohen",
              "FirstName":"Meredith",
              "LastName":"Cohen",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":466779,
              "UserName":"DColes",
              "FirstName":"Danielle",
              "LastName":"Coles",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":541315,
              "UserName":"NCollura",
              "FirstName":"Noelle",
              "LastName":"Collura",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":451452,
              "UserName":"LColon",
              "FirstName":"Luis",
              "LastName":"Colon",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":316277,
              "UserName":"JConboy",
              "FirstName":"Joanna",
              "LastName":"Conboy",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26506,
              "UserName":"mcottone",
              "FirstName":"Maria",
              "LastName":"Cottone",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26509,
              "UserName":"JDady",
              "FirstName":"Jane",
              "LastName":"Dady",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":882412,
              "UserName":"MDale1",
              "FirstName":"Michelle",
              "LastName":"Dale",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26512,
              "UserName":"KDarling",
              "FirstName":"Kelly",
              "LastName":"Darling",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":6803,
              "UserName":"DDauria",
              "FirstName":"Denise",
              "LastName":"Dauria",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26533,
              "UserName":"NDaviortiz",
              "FirstName":"Nancy",
              "LastName":"Davi-Ortiz",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":6805,
              "UserName":"ADelgiorno",
              "FirstName":"Alyssa",
              "LastName":"DelGiorno",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":466780,
              "UserName":"JJohnson",
              "FirstName":"Jaclynn",
              "LastName":"Dematos",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":711060,
              "UserName":"NDeMonda",
              "FirstName":"Nicholas",
              "LastName":"DeMonda",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":797771,
              "UserName":"DDesiderio",
              "FirstName":"Dana",
              "LastName":"Desiderio",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":811276,
              "UserName":"CDiaz",
              "FirstName":"Claudia",
              "LastName":"Diaz",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26517,
              "UserName":"JDibble",
              "FirstName":"Jennifer",
              "LastName":"Dibble",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":882402,
              "UserName":"PDiek",
              "FirstName":"Patti",
              "LastName":"Dieck",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26520,
              "UserName":"RDillahunt",
              "FirstName":"Rebekah",
              "LastName":"Dillahunt",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":882418,
              "UserName":"CDiot4",
              "FirstName":"Chris",
              "LastName":"Diot",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":796378,
              "UserName":"DDiPietrantonio",
              "FirstName":"Dina",
              "LastName":"DiPietrantonio",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":13422,
              "UserName":"mdispenziere",
              "FirstName":"Michael",
              "LastName":"Dispenziere",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":479456,
              "UserName":"Jdistler",
              "FirstName":"Jeanette",
              "LastName":"Distler",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":343075,
              "UserName":"jdriscoll",
              "FirstName":"Jessica",
              "LastName":"Driscoll",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26652,
              "UserName":"NFaber",
              "FirstName":"Nicole",
              "LastName":"Faber",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":466768,
              "UserName":"PFallot",
              "FirstName":"Patrick",
              "LastName":"Fallot",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":466777,
              "UserName":"RFallot",
              "FirstName":"Ryan",
              "LastName":"Fallot",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":94616,
              "UserName":"kfaulkner",
              "FirstName":"Kerrin",
              "LastName":"Faulkner",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":891479,
              "UserName":"rfeehan@amityvilleufsd.org",
              "FirstName":"Rebecca",
              "LastName":"Feehan",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":466770,
              "UserName":"JFeliz",
              "FirstName":"Johanna",
              "LastName":"Feliz",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":538967,
              "UserName":"FFerber",
              "FirstName":"Francine",
              "LastName":"Ferber",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":466785,
              "UserName":"BFerrante",
              "FirstName":"Bianca",
              "LastName":"Ferrante",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26808,
              "UserName":"CFerrara",
              "FirstName":"Carl",
              "LastName":"Ferrara",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":711057,
              "UserName":"JFishman",
              "FirstName":"Josh",
              "LastName":"Fishman",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26535,
              "UserName":"JFloyd",
              "FirstName":"Jacqueline",
              "LastName":"Floyd",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":489846,
              "UserName":"JFlyntz",
              "FirstName":"Jennifer",
              "LastName":"Flyntz-Zider",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26537,
              "UserName":"AFox",
              "FirstName":"Annette",
              "LastName":"Fox",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":43396,
              "UserName":"RFrey",
              "FirstName":"Ruth",
              "LastName":"Frey",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":882414,
              "UserName":"SGafarian1",
              "FirstName":"Steven",
              "LastName":"Gafarian",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":525081,
              "UserName":"JGalasso",
              "FirstName":"Jennifer",
              "LastName":"Galasso",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26542,
              "UserName":"TGandarillas",
              "FirstName":"Teresa",
              "LastName":"Gandarillas",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":337171,
              "UserName":"cgannon",
              "FirstName":"Christopher",
              "LastName":"Gannon",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":115572,
              "UserName":"CGarofalo",
              "FirstName":"Cara",
              "LastName":"Garofalo",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26809,
              "UserName":"dgeiger",
              "FirstName":"Deborah",
              "LastName":"Geiger",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26546,
              "UserName":"KGeilman",
              "FirstName":"Kelli",
              "LastName":"Geilman",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":451457,
              "UserName":"PGermain",
              "FirstName":"Pascal",
              "LastName":"Germain",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":711063,
              "UserName":"GGiordano",
              "FirstName":"Graceann",
              "LastName":"Giordano",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":817154,
              "UserName":"AGonzalez",
              "FirstName":"Adriana",
              "LastName":"Gonzalez",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":882411,
              "UserName":"DGraham1",
              "FirstName":"Denise",
              "LastName":"Graham",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26551,
              "UserName":"JGrasso",
              "FirstName":"Jayne",
              "LastName":"Grasso",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":447005,
              "UserName":"pgrasso",
              "FirstName":"Paul",
              "LastName":"Grasso",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26811,
              "UserName":"mgrecopa",
              "FirstName":"Michael",
              "LastName":"Greco",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26552,
              "UserName":"mgreiss",
              "FirstName":"Matthew",
              "LastName":"Greiss",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26553,
              "UserName":"sgriffinnw",
              "FirstName":"Shannon",
              "LastName":"Griffin",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26556,
              "UserName":"IHamilton",
              "FirstName":"Isha",
              "LastName":"Hamilton",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26557,
              "UserName":"KHarpaul",
              "FirstName":"Kelly",
              "LastName":"Harpaul",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":484650,
              "UserName":"AHarris",
              "FirstName":"Ada",
              "LastName":"Harris",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26558,
              "UserName":"Aharrisne",
              "FirstName":"Angela",
              "LastName":"Harris",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":724562,
              "UserName":"AHartung",
              "FirstName":"Adrienne",
              "LastName":"Hartung",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26562,
              "UserName":"LHeavey",
              "FirstName":"Lori",
              "LastName":"Heavey",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":891478,
              "UserName":"lheck@amityvilleufsd.org",
              "FirstName":"Laurie",
              "LastName":"Heck",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26566,
              "UserName":"AHenriksen",
              "FirstName":"Andrew",
              "LastName":"Henriksen",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26567,
              "UserName":"AHernandez-Belarj",
              "FirstName":"Aida",
              "LastName":"Hernandez-Belarj",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26568,
              "UserName":"DHerz",
              "FirstName":"Dana",
              "LastName":"Herz",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":444021,
              "UserName":"MHoward",
              "FirstName":"Margot",
              "LastName":"Howard",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":430606,
              "UserName":"LHuremovic",
              "FirstName":"Lejla",
              "LastName":"Huremovic",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26573,
              "UserName":"LIannotta",
              "FirstName":"Lisa",
              "LastName":"Iannotta",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":541507,
              "UserName":"DImpagliazzo",
              "FirstName":"Diane",
              "LastName":"Impagliazzo",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":361521,
              "UserName":"sjames",
              "FirstName":"Sandra",
              "LastName":"James",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26576,
              "UserName":"FJohn",
              "FirstName":"Francine",
              "LastName":"John",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":451470,
              "UserName":"JJorgensen",
              "FirstName":"Justin",
              "LastName":"Jorgensen",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26581,
              "UserName":"GKarafantis",
              "FirstName":"George",
              "LastName":"Karafantis",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26582,
              "UserName":"AKarniewich",
              "FirstName":"Adeline",
              "LastName":"Karniewich",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26629,
              "UserName":"OAmoruso-Karounos",
              "FirstName":"Olimpia",
              "LastName":"Karounos",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26583,
              "UserName":"jakatsigiorgis",
              "FirstName":"Janine",
              "LastName":"Katsigiorgis",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":4096,
              "UserName":"jkatsigiorgi",
              "FirstName":"John",
              "LastName":"Katsigiorgis",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26587,
              "UserName":"NKeaveny",
              "FirstName":"Nidia",
              "LastName":"Keaveny",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26588,
              "UserName":"kkeenan",
              "FirstName":"Kara",
              "LastName":"Keenan",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26591,
              "UserName":"CKilfoil",
              "FirstName":"Christine",
              "LastName":"Kilfoil",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":811273,
              "UserName":"JKirschen",
              "FirstName":"Julie",
              "LastName":"Kirschen",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":416553,
              "UserName":"CKlimek",
              "FirstName":"Christine",
              "LastName":"Klimek",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26593,
              "UserName":"KKomsic",
              "FirstName":"Kristina",
              "LastName":"Komsic",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":94661,
              "UserName":"DKoraus",
              "FirstName":"Debra",
              "LastName":"Koraus",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":400021,
              "UserName":"AKretz",
              "FirstName":"Allyson",
              "LastName":"Kretz",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26599,
              "UserName":"WKretz",
              "FirstName":"William",
              "LastName":"Kretz",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":384210,
              "UserName":"Kkuletsky",
              "FirstName":"Krystle",
              "LastName":"Kuletsky",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":537391,
              "UserName":"ALapersonerie",
              "FirstName":"Alison",
              "LastName":"Lapersonerie",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":525077,
              "UserName":"CLettieri",
              "FirstName":"Christopher",
              "LastName":"Lettieri",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26607,
              "UserName":"MLievano",
              "FirstName":"Maria",
              "LastName":"Lievano",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":525075,
              "UserName":"NLim",
              "FirstName":"Natasha",
              "LastName":"Lim",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":586490,
              "UserName":"dalisle",
              "FirstName":"Daniel",
              "LastName":"Lisle",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":811288,
              "UserName":"CLocher",
              "FirstName":"Christine",
              "LastName":"Locher",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26609,
              "UserName":"MLoiacono",
              "FirstName":"Mary Ellen",
              "LastName":"Loiacono",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":490096,
              "UserName":"GLouis",
              "FirstName":"Gerde",
              "LastName":"Louis",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":586483,
              "UserName":"klovett_nw",
              "FirstName":"Kristie",
              "LastName":"Lovett",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26814,
              "UserName":"JMaccarone",
              "FirstName":"Jolene",
              "LastName":"Maccarone",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26613,
              "UserName":"WMaisel",
              "FirstName":"William",
              "LastName":"Maisel",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":586487,
              "UserName":"thmaloney",
              "FirstName":"Thomas",
              "LastName":"Maloney",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26615,
              "UserName":"MMarchino",
              "FirstName":"Mark",
              "LastName":"Marchino",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26616,
              "UserName":"MMariano",
              "FirstName":"Matthew",
              "LastName":"Mariano",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":525090,
              "UserName":"MMartin",
              "FirstName":"Megan",
              "LastName":"Martin",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":811284,
              "UserName":"MMartin1",
              "FirstName":"Monica Robyn",
              "LastName":"Martin",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26618,
              "UserName":"CMartine",
              "FirstName":"Charles",
              "LastName":"Martine",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26822,
              "UserName":"AMcCabe",
              "FirstName":"Anthony",
              "LastName":"McCabe",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":407920,
              "UserName":"VLitras",
              "FirstName":"Victoria",
              "LastName":"McClafferty",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":882417,
              "UserName":"BMcCormick",
              "FirstName":"Brian",
              "LastName":"McCormack",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26675,
              "UserName":"MMcCormack",
              "FirstName":"Melissa",
              "LastName":"McCormack",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":882400,
              "UserName":"tmccormack@amityvilleufsd.org",
              "FirstName":"Theresa",
              "LastName":"McCormack",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":337170,
              "UserName":"gmccoy",
              "FirstName":"Gregory",
              "LastName":"McCoy",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26678,
              "UserName":"JMcGowan",
              "FirstName":"Jason",
              "LastName":"McGowan",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":799352,
              "UserName":"MMedici",
              "FirstName":"Melissa",
              "LastName":"Medici",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26823,
              "UserName":"PMeisser",
              "FirstName":"Patricia",
              "LastName":"Meisser",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":525084,
              "UserName":"CMejia",
              "FirstName":"Carolyn",
              "LastName":"Mejia",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26825,
              "UserName":"TPesale",
              "FirstName":"Tiffany",
              "LastName":"Mendelson",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":819013,
              "UserName":"IMetaxas",
              "FirstName":"Irene",
              "LastName":"Metaxas",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26681,
              "UserName":"CMetz",
              "FirstName":"Christine",
              "LastName":"Metz",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26682,
              "UserName":"smeyeramv",
              "FirstName":"Sage",
              "LastName":"Meyer",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26683,
              "UserName":"LMilan",
              "FirstName":"Lesia",
              "LastName":"Milan",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26606,
              "UserName":"dmizrachi",
              "FirstName":"Dawn",
              "LastName":"Mizrachi",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":811282,
              "UserName":"MMorales",
              "FirstName":"Michelle",
              "LastName":"Morales",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":94633,
              "UserName":"JNewman",
              "FirstName":"Jared",
              "LastName":"Newman",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26694,
              "UserName":"fobrienms",
              "FirstName":"Frank",
              "LastName":"O'Brien",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":588685,
              "UserName":"kpallini",
              "FirstName":"Kathryn",
              "LastName":"Pallini",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":451459,
              "UserName":"NPappas",
              "FirstName":"Nicole",
              "LastName":"Pappas",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26824,
              "UserName":"RPariser",
              "FirstName":"Rachel",
              "LastName":"Pariser",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":882407,
              "UserName":"EPascal",
              "FirstName":"Esther",
              "LastName":"Pascal",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26700,
              "UserName":"JPellegrino",
              "FirstName":"Jaime",
              "LastName":"Pellegrino",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26701,
              "UserName":"RPellegrino",
              "FirstName":"Richard",
              "LastName":"Pellegrino",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26703,
              "UserName":"JPepe",
              "FirstName":"Jennifer",
              "LastName":"Pepe",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26705,
              "UserName":"bperez",
              "FirstName":"Barbara",
              "LastName":"Perez",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":880319,
              "UserName":"JPeshler3",
              "FirstName":"Joan",
              "LastName":"Peshler",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":19830,
              "UserName":"jpiccirilli",
              "FirstName":"Jeffrey",
              "LastName":"Piccirilli",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":812417,
              "UserName":"NPlaia",
              "FirstName":"Nicole",
              "LastName":"Plaia",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":882408,
              "UserName":"EPlatt2",
              "FirstName":"Elbert",
              "LastName":"Platt",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26826,
              "UserName":"APoulin",
              "FirstName":"Anne",
              "LastName":"Poulin",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26717,
              "UserName":"LPowers",
              "FirstName":"Lisa",
              "LastName":"Powers",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":819207,
              "UserName":"CPravata1",
              "FirstName":"Christine",
              "LastName":"Pravata",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26721,
              "UserName":"JPuglisi",
              "FirstName":"Joseph",
              "LastName":"Puglisi",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26722,
              "UserName":"CQuigley",
              "FirstName":"Christine",
              "LastName":"Quigley",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":43526,
              "UserName":"TQuinn",
              "FirstName":"Tim",
              "LastName":"Quinn",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":407906,
              "UserName":"SRamgadoo",
              "FirstName":"Sylvin",
              "LastName":"Ramgadoo",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26766,
              "UserName":"Lrandolph1",
              "FirstName":"Lisa",
              "LastName":"Randolph",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":711062,
              "UserName":"KReavy",
              "FirstName":"Kelsey",
              "LastName":"Reavy",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26725,
              "UserName":"MReddin",
              "FirstName":"Mackenzie",
              "LastName":"Reddin",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":7271,
              "UserName":"areichel",
              "FirstName":"Allison",
              "LastName":"Reichel",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26727,
              "UserName":"HReiner",
              "FirstName":"Howard",
              "LastName":"Reiner",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":316275,
              "UserName":"JReplak",
              "FirstName":"James",
              "LastName":"Replak",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":689948,
              "UserName":"SRexach",
              "FirstName":"Sally Anne",
              "LastName":"Rexach",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":451462,
              "UserName":"HRickard",
              "FirstName":"Heather",
              "LastName":"Rickard",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26730,
              "UserName":"lrobinson1",
              "FirstName":"Lydia",
              "LastName":"Robinson",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":361634,
              "UserName":"srochester",
              "FirstName":"Seth",
              "LastName":"Rochester",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26731,
              "UserName":"LRoddin",
              "FirstName":"Laurette",
              "LastName":"Roddin",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":29235,
              "UserName":"jrodriguezamv",
              "FirstName":"John",
              "LastName":"Rodriguez",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26733,
              "UserName":"jromanamv",
              "FirstName":"Juliane",
              "LastName":"Roman",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":469105,
              "UserName":"CLRomeo",
              "FirstName":"Christina",
              "LastName":"Romeo",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":100794,
              "UserName":"KDodd",
              "FirstName":"Kathryn",
              "LastName":"Rosario",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":797935,
              "UserName":"NRosario",
              "FirstName":"Nicole",
              "LastName":"Rosario",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26724,
              "UserName":"JRosenberg",
              "FirstName":"Jaclyn",
              "LastName":"Rosenberg",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26737,
              "UserName":"dross",
              "FirstName":"Deborah",
              "LastName":"Ross",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":586498,
              "UserName":"sroy",
              "FirstName":"Stephanie",
              "LastName":"Roy",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26741,
              "UserName":"MRudden",
              "FirstName":"Michele",
              "LastName":"Rudden",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":407878,
              "UserName":"LRuggiero",
              "FirstName":"Leighann",
              "LastName":"Ruggiero",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":882416,
              "UserName":"Modigliani",
              "FirstName":"Susan",
              "LastName":"Rutigliano",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":711061,
              "UserName":"JSanchez",
              "FirstName":"Jennifer",
              "LastName":"Sanchez",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26745,
              "UserName":"CSarlo",
              "FirstName":"Chris",
              "LastName":"Sarlo",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26668,
              "UserName":"JCobian",
              "FirstName":"Janine",
              "LastName":"Sarlo",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":525082,
              "UserName":"KSarris",
              "FirstName":"Katerina",
              "LastName":"Sarris",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26746,
              "UserName":"PScavo",
              "FirstName":"Patrice",
              "LastName":"Scavo",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":466773,
              "UserName":"MScharf",
              "FirstName":"Mary",
              "LastName":"Scharf",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":525080,
              "UserName":"PScherzinger",
              "FirstName":"Patricia",
              "LastName":"Scherzinger",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":694906,
              "UserName":"JSchulken",
              "FirstName":"Jennifer",
              "LastName":"Schulken",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":545687,
              "UserName":"JSchweigert",
              "FirstName":"Jennifer",
              "LastName":"Schweigert",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":469032,
              "UserName":"NScoca",
              "FirstName":"Nicole",
              "LastName":"Scoca",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":23308,
              "UserName":"jseubert",
              "FirstName":"James",
              "LastName":"Seubert",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26755,
              "UserName":"RSilon",
              "FirstName":"Renee",
              "LastName":"Silon",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":480926,
              "UserName":"JSilvaCruz",
              "FirstName":"Jo Ann",
              "LastName":"Silva-Cruz",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":43436,
              "UserName":"MJones",
              "FirstName":"Mackenzie",
              "LastName":"Sipp",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":343070,
              "UserName":"xskaliotis",
              "FirstName":"Ximena",
              "LastName":"Skaliotis",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":525079,
              "UserName":"JSmith",
              "FirstName":"Jenny",
              "LastName":"Smith",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26759,
              "UserName":"TSmith",
              "FirstName":"Tina",
              "LastName":"Smith",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26720,
              "UserName":"Usomapeera",
              "FirstName":"Urszula",
              "LastName":"Somapeera",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":537260,
              "UserName":"KSoto",
              "FirstName":"Kenia",
              "LastName":"Soto",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26761,
              "UserName":"cspatola",
              "FirstName":"Carl",
              "LastName":"Spatola",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":586485,
              "UserName":"ASteiger",
              "FirstName":"Angela",
              "LastName":"Steiger",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26828,
              "UserName":"AStein",
              "FirstName":"Amy",
              "LastName":"Stein",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":387330,
              "UserName":"NSteinberg",
              "FirstName":"Nicole",
              "LastName":"Steinberg",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":820962,
              "UserName":"KStevenson",
              "FirstName":"Kendra",
              "LastName":"Stevenson",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26765,
              "UserName":"DTakseraas",
              "FirstName":"David",
              "LastName":"Takseraas",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":466772,
              "UserName":"NBass",
              "FirstName":"Nicole",
              "LastName":"Tanbasi",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":882401,
              "UserName":"JTandy1",
              "FirstName":"Jeannette",
              "LastName":"Tandy",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":82597,
              "UserName":"elemTeacher",
              "FirstName":"Elementary",
              "LastName":"Teacher",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":709433,
              "UserName":"rrtteacher",
              "FirstName":"RRT",
              "LastName":"Teacher",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":692577,
              "UserName":"KTesoro",
              "FirstName":"Katie",
              "LastName":"Tesoro",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26767,
              "UserName":"GThompson",
              "FirstName":"Georgette",
              "LastName":"Thompson",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26768,
              "UserName":"KThorn",
              "FirstName":"Kathleen",
              "LastName":"Thorn",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":525087,
              "UserName":"MTomasi",
              "FirstName":"Matthew",
              "LastName":"Tomasi",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26771,
              "UserName":"HTortorici",
              "FirstName":"Heather",
              "LastName":"Tortorici",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26774,
              "UserName":"JTrotman",
              "FirstName":"Jennifer",
              "LastName":"Trotman",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":542915,
              "UserName":"JTsunis",
              "FirstName":"Jordan",
              "LastName":"Tsunis",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26777,
              "UserName":"DTwomey",
              "FirstName":"Donald",
              "LastName":"Twomey",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26778,
              "UserName":"LDambrose",
              "FirstName":"Linda",
              "LastName":"Valla-Dambrose",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26793,
              "UserName":"BWhite",
              "FirstName":"Brian",
              "LastName":"White",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":316269,
              "UserName":"sWhitney",
              "FirstName":"Sandy",
              "LastName":"Whitney",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26732,
              "UserName":"JRoisman",
              "FirstName":"Jodi",
              "LastName":"Wilsher",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26797,
              "UserName":"kwilsonamv",
              "FirstName":"Kelly",
              "LastName":"Wilson",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26799,
              "UserName":"BWishin",
              "FirstName":"Brian",
              "LastName":"Wishin",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26800,
              "UserName":"JSabbatino",
              "FirstName":"Jaclyn",
              "LastName":"Wittschiebe",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26802,
              "UserName":"SZabicki",
              "FirstName":"Susanne",
              "LastName":"Zabicki",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":882409,
              "UserName":"CZachary",
              "FirstName":"Corinne",
              "LastName":"Zachary",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":525078,
              "UserName":"SZaratin",
              "FirstName":"Susan",
              "LastName":"Zaratin",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":26804,
              "UserName":"LZomback",
              "FirstName":"Lisa",
              "LastName":"Zomback",
              "Active":true,
              "UserTypeId":2
           },
           {
              "CustID":105,
              "UserID":451461,
              "UserName":"CZwerling",
              "FirstName":"Corey",
              "LastName":"Zwerling",
              "Active":true,
              "UserTypeId":2
           }
        ]
     };

     public classes:ELearningDashboardClass[] =[];

     public classesFromTeacherID: ELearningDashboardClass[] = [
        {
           "ID":944892,
           "Name":"Intermediate Algebra",
           "Hidden":false,
           
           "CurriculumID":null,
           "ClassHomePageUrl":"/classroom?classID=944892&className=Intermediate+Algebra",
           "CurriculumUrl":"/Curriculum/View/",
           "NoLessonsYet":true,
           "Students":[
              {
                 "ID":831071,
                 "Name":"Winter, Avante",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":27094,
                 "Name":"Barrios, Daniel",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":27252,
                 "Name":"Miller, Jo'siah",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":27454,
                 "Name":"Scott, Lily",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":27867,
                 "Name":"Precil, Aaliyah",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":525111,
                 "Name":"Perez Lebron, Rubby",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":586618,
                 "Name":"Cruz Reyes, Fernando",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":690781,
                 "Name":"Fernandez Rodriguez, Liliana",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":799680,
                 "Name":"Magana Villalobos, Brayan",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              }
           ]
        },
        {
           "ID":945669,
           "Name":"Intermediate Algebra",
           "Hidden":false,
           
           "CurriculumID":null,
           "ClassHomePageUrl":"/classroom?classID=945669&className=Intermediate+Algebra",
           "CurriculumUrl":"/Curriculum/View/",
           "NoLessonsYet":true,
           "Students":[
              {
                 "ID":26984,
                 "Name":"Hibbert, Aria",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":27831,
                 "Name":"Thornton, Justin",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":27987,
                 "Name":"Barrera-Cruz, Michelle",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":43610,
                 "Name":"Lyte, Brandon",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":543390,
                 "Name":"Alas Diaz, Briseyda",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":688668,
                 "Name":"Sanchez, Cristian",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":26860,
                 "Name":"Taylor, Adrianne",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":142357,
                 "Name":"Moore, Christian",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":712115,
                 "Name":"Ortiz Garcia, Randy",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":721370,
                 "Name":"Plasencia Yon, Ruben",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":815355,
                 "Name":"Martinez Flores, Omar",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              }
           ]
        },
        {
           "ID":945670,
           "Name":"Intermediate Algebra",
           "Hidden":false,
           
           "CurriculumID":null,
           "ClassHomePageUrl":"/classroom?classID=945670&className=Intermediate+Algebra",
           "CurriculumUrl":"/Curriculum/View/",
           "NoLessonsYet":true,
           "Students":[
              {
                 "ID":27005,
                 "Name":"Rubio-Cruz, Anthony",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":27514,
                 "Name":"Dilone Rodriguez, Angel",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":27914,
                 "Name":"Villalobos, Cesar",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":27181,
                 "Name":"Tucciarone, Drezden",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":27367,
                 "Name":"Diaz Garcia, Margarita",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              }
           ]
        },
        {
           "ID":945671,
           "Name":"Accounting",
           "Hidden":false,
           
           "CurriculumID":null,
           "ClassHomePageUrl":"/classroom?classID=945671&className=Accounting",
           "CurriculumUrl":"/Curriculum/View/",
           "NoLessonsYet":true,
           "Students":[
              {
                 "ID":26950,
                 "Name":"Pereira Vigil, Jeffrey",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":27310,
                 "Name":"Aviles Martinez, Kevin",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":27974,
                 "Name":"Dockery, Kenji",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":94615,
                 "Name":"Jimenez, Nicole",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":451471,
                 "Name":"Dieudonne, Aidan",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":26903,
                 "Name":"Garnett, Darien",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":115676,
                 "Name":"Leano, Messiah",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":343161,
                 "Name":"Reyes Ortez, Francisco",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":586677,
                 "Name":"Johnson, Imani",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":811555,
                 "Name":"Simmons, Wynter",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              }
           ]
        },
        {
           "ID":945696,
           "Name":"Geometry",
           "Hidden":false,
           
           "CurriculumID":null,
           "ClassHomePageUrl":"/classroom?classID=945696&className=Geometry",
           "CurriculumUrl":"/Curriculum/View/",
           "NoLessonsYet":true,
           "Students":[
              {
                 "ID":26905,
                 "Name":"Chester III, Robert",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":27002,
                 "Name":"Bonilla, Billy",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":115649,
                 "Name":"Zelaya, Sarai",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":445146,
                 "Name":"Montauban, Jae'lyn",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":546723,
                 "Name":"Freeman, Aniyah",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":795378,
                 "Name":"Pacheco Reyes, Florentina",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":26964,
                 "Name":"Maldonado, Kevin",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":27258,
                 "Name":"Tapanes, Kenneth",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":27383,
                 "Name":"McIntyre, Mark",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":387384,
                 "Name":"Stewart, Jimmie",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":416565,
                 "Name":"Williamson, Nasir",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              }
           ]
        },
        {
           "ID":1014720,
           "Name":"Seminar- Traditional 10TH GRADE",
           "Hidden":false,
           
           "CurriculumID":null,
           "ClassHomePageUrl":"/classroom?classID=1014720&className=Seminar-+Traditional+10TH+GRADE",
           "CurriculumUrl":"/Curriculum/View/",
           "NoLessonsYet":true,
           "Students":[
              {
                 "ID":27027,
                 "Name":"Chavez, Hedilberto",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":27300,
                 "Name":"Gil, Joel",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":27980,
                 "Name":"Dixon, Magnus",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":26859,
                 "Name":"Barrera, Katherine",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":27126,
                 "Name":"Canales-Vasquez, Derek",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":27190,
                 "Name":"Hernandez Morency, Sophia",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":27373,
                 "Name":"Herrero, Emily",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":43613,
                 "Name":"Gunter, Brianna",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":586580,
                 "Name":"DePadua Acosta, Diego",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              },
              {
                 "ID":586668,
                 "Name":"Hernandez Gamez, Katherine",
                 "NeedsAssignment":true,
                 "LastAssignmentSubmitDate":"",
                 "NeedsGradingCount":0,
                 "NeedsGradeReleasedCount":0,
                 "ActiveLessons":0
              }
           ]
        }
     ];
}

export class TeacherNoClasses {
    public teachers: Teachers = {
        IsAdmin:false,
        Teachers:[]
    };
    public classes: ELearningDashboardClass[] = [];
}

export class TeacherNoStudentsInClass {
    public teachers: Teachers = {
        IsAdmin:false,
        Teachers:[]
    };

    public classes: ELearningDashboardClass[] = [
        {"ID":563528,"NoLessonsYet": false,"Name":"Economics","Hidden":false,"CurriculumID":1,"ClassHomePageUrl":"/classroom?classID=563528&className=Economics","CurriculumUrl":"/Curriculum/View/","Students":[]}
    ];
}

export class AdminWithTeacherWithNoStudentInClass{
    public teachers: Teachers = {
        IsAdmin:true,
        Teachers:[{"CustID":105,"UserID":525104,"UserName":"JAdaHarris","FirstName":"Jenny Smith","LastName":"Ada Harris","Active":true,"UserTypeId":2}]
    };

    public classes: ELearningDashboardClass[] = [];

    public classesFromTeacherID: ELearningDashboardClass[] = [{"ID":563528,"NoLessonsYet": false,"Name":"Economics","Hidden":false,"CurriculumID":1,"ClassHomePageUrl":"/classroom?classID=563528&className=Economics","CurriculumUrl":"/Curriculum/View/","Students":[]}];
}

export class AdminNoTeachers {
    public teachers: Teachers = {
        IsAdmin:true,
        Teachers:[]
    };

    public classes: ELearningDashboardClass[] = [];

    public classesFromTeacherID: ELearningDashboardClass[] = [];
}

export class AdminWithTeacherWithNoClassses {
    public teachers: Teachers = {
        IsAdmin:true,
        Teachers:[{"CustID":105,"UserID":525104,"UserName":"JAdaHarris","FirstName":"Jenny Smith","LastName":"Ada Harris","Active":true,"UserTypeId":2}]
    };
    
    public classes: ELearningDashboardClass[] = [];

    public classesFromTeacherID: ELearningDashboardClass[] = [];
}

